<template>
  <v-card
    color="grey lighten-4"
    light
  >
    <v-card-text>
      <content-section
        title="Mon objectif"
      >
        Je suis à la recherche d’une mission en tant que Concepteur Développeur ou Technicien Support Informatique
      </content-section>
      <content-section
        v-if="prouds"
        title="Mes compétences"
      >
        <v-layout
          v-for="(proud, i) in prouds"
          :key="i"
        >
          <v-flex
            md1
            xs3
          >
            <v-icon right>
              {{ proud.icon }}
            </v-icon>
          </v-flex>
          <v-flex
            md11
            xs9
          >
            <div>
              <strong>{{ proud.text }}</strong><br>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <p v-html="proud.source" />
              <!-- <p>{{ proud.source }}</p>/> -->
            </div>
          </v-flex>
        </v-layout>
      </content-section>
      <content-section
        v-if="educations"
        title="Mon parcours"
      >
        <v-layout
          v-for="(education, i) in educations"
          :key="i"
        >
          <v-flex md4>
            {{ education.from }} - {{ education.to }}
          </v-flex>
          <v-flex md8>
            <strong v-if="education.title">{{ education.title }}</strong>
            <div v-if="education.location">
              <small><i>{{ education.location }}</i></small>
            </div>
            <div v-if="education.description">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div v-html="education.description" />
              <!-- <div>{{ education.description }}</div> -->
            </div>
          </v-flex>
        </v-layout>
      </content-section>
      <content-section
        v-if="skills"
        id="to-timeline"
        title="Technos"
      >
        <template slot="actions">
          (%)
        </template>
        <v-layout wrap>
          <template
            v-for="(skill, i) in skills"
          >
            <v-flex
              v-if="skill.divider"
              :key="i"
              md12
              xs12
              mb-4
            />
            <v-flex
              v-else
              :key="i"
              md6
              xs12
            >
              <div
                class="mr-2 ml-2"
              >
                <div class="align-center">
                  <v-icon
                    small
                  >
                    {{ skill.icon }}
                  </v-icon>
                  {{ skill.title }}
                </div>
                <v-progress-linear
                  class="progress"
                  color="secondary"
                  height="3"
                  :value="skill.value"
                />
              </div>
            </v-flex>
          </template>
        </v-layout>
      </content-section>
    </v-card-text>
  </v-card>
</template>

<script>
import ContentSection from '@/views/dark-template/content/Section'
export default {
  name      : 'MainContent',
  components: { ContentSection },
  data      : () => ({
    prouds: [
      {
        icon  : 'mdi-tournament',
        text  : 'Champs d’application',
        source: '&#10070; Testapproval1 without poll +7- Développement de projets Java SE, Java EE, WinForm, ASP.NET, Android, AngularJS, Vue.js, Node.js<br/>&#10070; Étude du cahier des charges et modélisation, travaux de réunion/projet<br/>&#10070; Conception fonctionnelle et technique, programmation, mise au point et documentation d’application<br/>&#10070; Conception, création et exploitation d’une base de données<br/>&#10070; Analyse des contraintes relationnelles d’une base de données, intégration de données multiplateforme<br/>&#10070; Intégration HTML5, CSS3, LESS, utilisation de XML, DOM, JSON - Approche sur l’ergonomie web, l’accessibilité, SEO - Configuration de serveur web, nom de domaine, serveur de BDD, serveur email',
      },
      {
        icon  : 'mdi-toolbox-outline',
        text  : 'Outils et langages',
        source: '&#10070; Plateformes de développement : IntelliJ Idea, Eclipse, STS, Android Studio, Visual Studio, VS Code<br/>&#10070; Langages, Outils et Frameworks : Java Swing, JavaFX, JSP, JSTL, JSF, EJB, JPA, ASP.NET, C#, PHP, Transact SQL, Services Web, jQuery, PrimeFaces, Bootstrap, Maven, Gradle, Spring, log4j, JavaDoc, Node.js, AngularJS, Vue.js, Docker, Kubernetes, Jenkins, Python, CSS3, LESS, Cerberus, Selenium, Mantis BT<br/>&#10070; Serveurs : Windows Server 2012, IIS, Linux, Apache, Tomcat, TomEE, JBoss AS, WildFly, Express<br/>&#10070; SGBD, persistance de données : SQL Server, MySQL, Hibernate, Talend Data Integration<br/>&#10070; Méthodes d’analyse/développement de projet : UML, Merise, Git, Scrum, MS Project<br/>&#10070; Bureautique et PAO : Office, Photoshop, Quark Xpress, Illustrator, InDesign et autres outils de traitement d’images et de données',
      },
    ],
    educations: [
      {
        from       : 'Février',
        to         : 'mai 2021',
        title      : 'Suivi de migration de surveillances',
        location   : 'Worldline, mission Espace Freelance - Armago à Noyelles-lès-Seclin',
        description: '&#10070; Suivi des migrations Application Monitor vers OPS Monitor (outils maison) auprès des équipes Worldline/ clients - contacts réguliers SDM, PO, CDP, équipes BU <br/>&#10070; Support migration Application Monitor, conseil de mise en œuvre monitorings OPS Monitor et suivi des anomalies rencontrées -Technos, outils : Prometheus, TimescaleDB, MongoDB, GitLab, Jira, Confluence<br/>&#10070; Animation Users club mensuel migration Application Monitor et utilisation OPS Monitor<br/>&#10070; Présentations OPS Monitor aux utilisateurs, documentation utilisateur',
      },
    ],
    skills: [
      {
        title: 'JavaScript',
        icon : 'mdi-language-javascript',
        value: 80,
      },
      {
        title: 'Vue.js Framework',
        icon : 'mdi-vuejs',
        value: 65,
      },
      {
        title: 'Java',
        icon : 'mdi-language-java',
        value: 75,
      },
      {
        title: 'C#',
        icon : 'mdi-language-csharp',
        value: 50,
      },
      {
        title: 'C/C++',
        icon : 'mdi-language-cpp',
        value: 15,
      },
      {
        title: 'HTLM5',
        icon : 'mdi-language-html5',
        value: 85,
      },
      {
        title: 'CSS3',
        icon : 'mdi-language-css3',
        value: 85,
      },
      {
        title: 'PHP',
        icon : 'mdi-language-php',
        value: 35,
      },

      {
        title: 'Laravel',
        icon : 'mdi-laravel',
        value: 20,
      },
      { divider: true },
      {
        title: 'Ubuntu Server',
        icon : 'mdi-ubuntu',
        value: 85,
      },
      {
        title: 'CentOS Server/Rocky',
        icon : 'mdi-linux',
        value: 70,
      },
      {
        title: 'Web Application Security',
        icon : 'mdi-shield-lock',
        value: 80,
      },
      {
        title: 'Test Driven Development',
        icon : 'mdi-test-tube',
        value: 15,
      },
      {
        title: 'Continuous Integration / Continuous Delivery',
        icon : 'mdi-truck-fast',
        value: 45,
      },
      {
        title: 'Git',
        icon : 'mdi-git',
        value: 57,
      },
      { divider: true },
      {
        title: 'Arduino',
        icon : 'mdi-chip',
        value: 30,
      },
      {
        title: 'Pi',
        icon : 'mdi-chip',
        value: 85,
      },
      { divider: true },
      {
        title: 'Scrum / Kanban',
        icon : 'mdi-view-dashboard',
        value: 45,
      },
      {
        title: 'Content Marketing',
        icon : 'mdi-text',
        value: 45,
      },
    ],
  }),
}
</script>

<style scoped>
.title {
  border-bottom: 2px #bfbfbf solid;
  line-height: 1.5 !important;
}
.progress {
  margin-top: 0.1rem;
}
.flex.md4 {
  max-width: 22%;
}
.flex.md8 {
  min-width: 78%;
  max-width: 78%;
}
.flex.md1.xs3 {
  max-width: 15%;
}
.flex.md11.xs9 {
  min-width: 85%;
}
</style>
